import { useEffect, useState } from 'react';

const MOBILE_QUERY = '(max-width: 768px)';

function getMatches(query) {
    return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
        ? window.matchMedia(query).matches
        : false;
}

export default function useIsMobile(query = MOBILE_QUERY) {
    const [matches, setMatches] = useState(getMatches(query));

    useEffect(() => {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;

        const media = window.matchMedia(query);
        const update = () => setMatches(media.matches);
        update();

        if (media.addEventListener) {
            media.addEventListener('change', update);
            return () => media.removeEventListener('change', update);
        }

        media.addListener(update);
        return () => media.removeListener(update);
    }, [query]);

    return matches;
}



// WEBPACK FOOTER //
// ./src/hooks/useIsMobile.js